// extracted by mini-css-extract-plugin
export default {"backdrop":"Dialog_backdrop__612kA","modal":"Dialog_modal__jxFyf"};